
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Semicolons`}</h1>
<p>{`Always use semicolons.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const a = 2
const b = 3

// Good
const a = 2;
const b = 3;
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;